import AES from "crypto-js/aes";
import Utf8 from "crypto-js/enc-utf8";
import { ENCRYPT_SECRET_KEY } from "./constants";

export const isMobile = (): boolean => {
  const toMatch = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i,
  ];
  return toMatch.some((toMatchItem) => {
    return navigator.userAgent.match(toMatchItem);
  });
};

export const isDesktop = (): boolean => {
  return !isMobile();
};

export const encryptData = (data: object | string): string => {
  try {
    const ciphertext = AES.encrypt(JSON.stringify(data), ENCRYPT_SECRET_KEY);
    return ciphertext.toString();
  } catch (error) {
    return ""
  }
};

export const decryptData = (ciphertext: string) => {
  try {
    const bytes = AES.decrypt(ciphertext, ENCRYPT_SECRET_KEY);
    const decryptedData = JSON.parse(bytes.toString(Utf8));
    return decryptedData;
  } catch (error) {
    return null
  }

};

export const setLocalStorage = (key: string, data: object | string): void => {
  window.localStorage.setItem(key, encryptData(data));
};

export const getLocalStorage = (key: string) => {
  return decryptData(window.localStorage.getItem(key) || "");
};

export const setSessionStorage = (key: string, data: object): void => {
  window.sessionStorage.setItem(key, encryptData(data));
};

export const getSessionStorage = (key: string) => {
  return decryptData(window.sessionStorage.getItem(key) || "");
};

export const removeSessionStorage = (key: string):void => {
  try {
    return window.sessionStorage.removeItem(key);
  } catch (error) {
    return    
  }
};

export const removeLocalStorage = (key: string):void => {
  try {
    return window.localStorage.removeItem(key);
  } catch (error) {
    return    
  }
};

export const clearLocalStorage = ():void => {
  try {
    return window.localStorage.clear();
  } catch (error) {
    return    
  }
};

export const hasVisitedWelcomePage = (): boolean => {
  try {
    return getLocalStorage('hasVisitedWelcomePage') === 'true';
  } catch (error) {
    return false;
  }
};

export const accessRoute = (): boolean => {
  try {
    // const accessToken = getLocalStorage('accessToken');
    const userId = getLocalStorage('userId');
    return !!userId;
  } catch (error) {
    return false;
  }
};

export const formatDateWithTime = (input: Date|string): string => {
  const date = new Date(input);

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  const hour = String(date.getHours()).padStart(2, '0');
  const minute = String(date.getMinutes()).padStart(2, '0');

  return `${day}/${month}/${year}, ${hour}:${minute}`;
};

export const isValidGuid = (guid:string): boolean => {
  const guidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$/;
  return guidRegex.test(guid);
}